<script setup lang="ts">
import { computed } from 'vue';
import { getDefaultDateFormat } from '@Helpers';

const props = defineProps<{
  field: any;
  rowData: any;
  settings: any;
}>();

const STATUS_LABELS: Record<string, string> = {
  due: 'components.formFields.password.expiryStatus.due',
  reset_requested: 'components.formFields.password.expiryStatus.resetRequested',
  scheduled: 'components.formFields.password.expiryStatus.scheduled',
};

const status = computed(() => String(props.rowData?.password_expiry_status ?? ''));
const statusLabelKey = computed(() => STATUS_LABELS[status.value] ?? null);
const isScheduled = computed(() => status.value === 'scheduled');

const formattedDate = computed(() => {
  const raw = props.field?.['$date']?.['$numberLong'] ?? props.field;

  return raw ? getDefaultDateFormat(raw) : null;
});
</script>

<template>
  <span
    v-if="statusLabelKey"
    :class="[
      'w-fit rounded-lg px-2 py-[3px] text-[10px] font-semibold',
      isScheduled ? 'bg-sky-100 text-sky-700' : 'bg-amber-100 text-amber-700',
    ]"
  >
    {{
      isScheduled
        ? $t(statusLabelKey, { date: formattedDate ?? '' })
        : $t(statusLabelKey)
    }}
  </span>

  <p v-else-if="formattedDate">
    {{ formattedDate }}
  </p>

  <span
    v-else
    class="flex flex-col items-start gap-0.5"
  >
    -
  </span>
</template>
